import type { StateCreator } from 'zustand';
import { initialPrescriptionHistoryState } from '../constants';
import type { PrescriptionAssistantSliceType } from '../types';

export const resetPrescriptionHistory: StateCreator<
  PrescriptionAssistantSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  () => void
> = (set) => () =>
  set(
    (state: PrescriptionAssistantSliceType) => {
      state.prescriptionAssistant.prescriptionHistory = initialPrescriptionHistoryState;
    },
    false,
    'prescriptionHistory/reset'
  );
